import React from "react";
import {
  Box,
  Typography,
  Tooltip,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ColorPallet } from "../../utils/colorPallet";

interface SubItem {
  id: number;
  href: string;
  title: string;
  icon?: React.ReactNode;
}

interface Props {
  title: string;
  subItems?: SubItem[];
  children: React.ReactNode;
}

function TooltipSubItems({ title, subItems, children }: Props) {
  const navigate = useNavigate();

  const handleNavigate = (href: string) => {
    navigate(href);
  };

  return (
    <Tooltip
      title={
        <Box
          sx={{
            p: 1.5,
            bgcolor: "#0B2238",
            color: "#fffff",
            boxShadow: "0px 4px 4px 0px #00000040",
             borderRadius: "10px"
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "100%",
              letterSpacing: "0%",
              mb: 0.5,
            }}
          >
            {title}
          </Typography>
          {Array.isArray(subItems) && subItems.length > 0 && (
            <List dense disablePadding>
              {subItems.map((sub) => (
                <ListItem
                  key={sub.id}
                  disablePadding
                  onClick={() => handleNavigate(sub.href)}
                  sx={{
                    cursor: "pointer",
                    px: 1,
                    py: 0.7,
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      bgcolor: ColorPallet.primaryBlue,
                      color: "#FFFFFF",
                      "& .MuiTypography-root": {
                        color: "#FFFFFF",
                      },
                    },
                  }}
                >
                  <ListItemText
                    primary={sub.title}
                    primaryTypographyProps={{
                      fontWeight: 400,
                      fontStyle: "regular",
                      fontSize: "13px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      color: "#fffff",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      }
      placement="right"
      arrow
      enterDelay={300}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#0B2238",
            padding: 0,
            boxShadow: "0px 4px 4px 0px #00000040",
            borderRadius: "10px"
          },
        },
        arrow: {
          sx: {
            color: "#0B2238", 
          },
        },
      }}
    >
      <Box>{children}</Box>
    </Tooltip>
  );
}

export default TooltipSubItems;
